import React, { forwardRef } from 'react';

import StudioShimmerBlock from '../../../../studio-blocks/components/StudioShimmerBlock';

import { useBlockContext } from '../../../contexts/block-context';
import { type HTMLProps } from '../factory';

export const BLOCK_GENERAL_HEADER_DATA_ATTR = 'data-block-general-header';

export type BlockHeaderElement = React.ElementRef<'div'>;
export interface BlockHeaderProps extends HTMLProps<'div'> {
  children: React.ReactNode;
}

export const BlockHeader = forwardRef<BlockHeaderElement, BlockHeaderProps>((props, ref) => {
  const { children } = props;
  const blockContext = useBlockContext();
  if (blockContext.isContinuation) return null;

  const setHeaderRef = (node: BlockHeaderElement | null) => {
    blockContext.setGeneralHeaderElement?.(node);

    if (typeof ref === 'function') {
      ref(node);
    } else if (ref) {
      ref.current = node;
    }
  };

  return (
    <React.Suspense fallback={<StudioShimmerBlock ref={ref} />}>
      <div className="flex flex-col" ref={setHeaderRef} {...{ [BLOCK_GENERAL_HEADER_DATA_ATTR]: '' }}>
        {children}
      </div>
    </React.Suspense>
  );
});

BlockHeader.displayName = 'BlockHeader';
